
import { Link }
  from 'react-router-dom';

import Content
  from 'app/components/content/Content';
import RouteServers
  from 'app/components/navigation/RouteServers';


const Sidebar = () => {
  return (
    <aside className="page-sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <Link to='/'>
            <span>
              <Content id="header.logo">
                <i>{/* Theme compatbility */}
                  <img
                    src='https://www.megaport.com/brand-center/logo-ver-dark.svg'
                    alt='Megaport'
                    width='40px' />
                </i>
              </Content>
            </span>
          </Link>
        </div>
        <div className="title">
          <h1><Content id="header.title">Alice</Content></h1>
          <p>
            <Content id="header.tagline">
              Your friendly BGP looking glass.
            </Content>
          </p>
        </div>
      </div>
      <RouteServers />
    </aside>
  );  
}

export default Sidebar;
